
    import './styles.scoped.css';
    export default {
  "universal-toolbar": "awsui_universal-toolbar_1kzri_1qdta_149",
  "with-ai-drawer": "awsui_with-ai-drawer_1kzri_1qdta_168",
  "universal-toolbar-ai-custom": "awsui_universal-toolbar-ai-custom_1kzri_1qdta_168",
  "disable-body-scroll": "awsui_disable-body-scroll_1kzri_1qdta_207",
  "toolbar-container": "awsui_toolbar-container_1kzri_1qdta_260",
  "universal-toolbar-nav": "awsui_universal-toolbar-nav_1kzri_1qdta_280",
  "universal-toolbar-breadcrumbs": "awsui_universal-toolbar-breadcrumbs_1kzri_1qdta_285",
  "universal-toolbar-drawers": "awsui_universal-toolbar-drawers_1kzri_1qdta_294",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_1kzri_1qdta_302",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_1kzri_1qdta_303",
  "drawers-trigger-content": "awsui_drawers-trigger-content_1kzri_1qdta_345",
  "group-divider": "awsui_group-divider_1kzri_1qdta_355",
  "drawers-trigger": "awsui_drawers-trigger_1kzri_1qdta_345",
  "block-body-scroll": "awsui_block-body-scroll_1kzri_1qdta_368"
};
  